import { type Context, useContext } from "react";

export interface ContextWithId<ContextType> {
	Context: Context<ContextType>;
	Id: string;
}

export function useContextWithId<ContextType>(
	context: ContextWithId<ContextType>
): NonNullable<ContextType> {
	const contextValue = useContext(context.Context);

	if (!contextValue) {
		throw new Error(`Missing context: ${context.Id}`);
	}

	return contextValue;
}
